import React, { useState } from "react"
import { Button } from "react-bootstrap"

import { registration } from "../../../modals/GraphEditModal"
import GraphEditModal from "../../../modals/GraphEditModal"

export default function GraphEditModalButton({
  loading,
  small,
  op,
  updateGraph,
  axesAndRanges,
  baseTime,
  timeExtractor,
  intl,
}) {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      {showModal && (
        <GraphEditModal
          show={showModal}
          onHide={() => setShowModal(false)}
          timeExtractor={timeExtractor}
          axesAndRanges={axesAndRanges}
          baseTime={baseTime}
          graphKey={op}
          intl={intl}
          updateGraph={updateGraph}
        />
      )}

      {registration.editingAllowed(op) && (
        <Button
          variant={"outline-primary"}
          onClick={(e) => setShowModal(true)}
          disabled={
            loading.length > 0 ||
            ((!op.observations || op.observations.length === 0) &&
              (!op.tags || op.tags.length === 0) &&
              (!op.microbes || op.microbes.length === 0))
          }
          className={small ? " btn-sm" : ""}
          title={registration["edit_graph_title"](intl)}
        >
          <span className={"fa fa-sliders"} aria-hidden="true" />
        </Button>
      )}
    </>
  )
}
